import FetchFactory from '../factory';

const CONTROLLER = '/api-electra/Insurance';

class InsuranceModule extends FetchFactory<any> {
  async AddInsuranceItemToOrder(
    orderGuid: string,
    cellPhoneOrderItemId: number,
  ) {
    const url = `${CONTROLLER}/AddInsuranceItemToOrder`;
    return await this.call('POST', url, {
      OrderGuid: orderGuid,
      CellPhoneOrderItemId: cellPhoneOrderItemId,
    });
  }
}

export default InsuranceModule;
